<template>
  <span
    :class="[
      'lp-label font-weight-medium',
      {
        'text-error': !preview && isError,
      },
    ]"
  >
    <slot>
      {{ label }}
    </slot>
    <span v-if="!preview && required" class="text-blue ml-half">*</span>
  </span>
</template>

<script setup lang="ts">
/**
 * This component is a very basic shell for the label component.
 *
 * It's still missing the specs from design, more advanced features, customizations and apply it to the rest of the components.
 */

type Props = {
  preview?: boolean | null
  required?: boolean | null
  isError?: boolean | null
  /**
   * Please use the default slot instead of this prop.
   */
  label?: string | null
}

defineOptions({
  name: 'lp-label',
})

withDefaults(defineProps<Props>(), {
  preview: false,
  required: false,
  isError: false,
  label: null,
})
</script>
